/*
    Тип узла
*/
export enum NodeDataType {
  Company = 1, // Компания
  Facility = 2, // Завод
  Workshop = 3, // Цех
  Machine = 4, // Станок
  MachineUnit = 5, // Узел станка
  Other = 6, // Другой
}

export const NodeTypeName = {
  [NodeDataType.Company]: 'Компания',
  [NodeDataType.Facility]: 'Предприятие',
  [NodeDataType.Workshop]: 'Цех',
  [NodeDataType.Machine]: 'Станок',
  [NodeDataType.MachineUnit]: 'Узел',
  [NodeDataType.Other]: 'Другой',
};
